import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from './errors.store';
import graphQl from '@/services/graphQl';
const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';
import axiosInstance from '@/services/api/http.service';
import getEnv from '@/utils/env';
import { AxiosResponse } from 'axios';
const actions: ActionTree<State, any> = {
  async getErrorData(
    context: { commit: Commit; rootState: any },
    params: {
      serviceId: String;
      queryDuration: any;
      paging: any;
      sortKey: String;
      searchKeyword: String;
      clientIP: String;
    }
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getErrors')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.queryBrowserErrorSummary;
        } else return [];
      })
      .catch((err) => console.log('error', err));
  },
  async getErrorDetail(
    context: { commit: Commit; rootState: any },
    params: {
      serviceId: String;
      queryDuration: any;
      paging: any;
      serviceVersionId: String;
      pagePathId: String;
      pagePath: String;
      category: String;
      sortKey: String;
      uniqueIds: Array<String>;
      userIds: Array<String>;
      browsers: Array<String>;
      devices: Array<String>;
      operatingSystems: Array<String>;
      message: String;
      searchKeyword: String;
    }
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getErrorLogs')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.queryBrowserErrorLogs;
        } else return [];
      });
  },
  async getEventDetail(
    context: { commit: Commit; rootState: any },
    params: {
      eventId: String;
    }
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getErrorLog')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.queryBrowserErrorLog;
        } else return {};
      });
  }
};

export default actions;
